<template>
    <section class="row">   
        <AlertMessage v-if="displayAlert" :message="alertMessage" :alertType="alertType" ></AlertMessage>
        
        <div class="col-lg-12 mb-5"  v-if="$route.query.copied !== undefined">
            <div class="col-lg-10 offset-lg-1 d-block no-gutters pl-0">
                    <div v-bind:class="alertMsg-info"> 
                        <p>
                            The saved application is copied.
                        </p>
                    </div>
            </div>
        </div>

        <div class="col-md-12" v-if="savedApplications.length > 0"><!--col-md-10 offset-md-1-->
            <!--<div>-->
                <!--<b-card no-body>-->
                    <b-tabs pills content-class="mt-2" v-model="tabIndex"> <!--card-->

                        <!--<b-tab active title-item-class="myTab">-->
                        <b-tab title-item-class="myTab mt-1 mr-3">
                            <template #title>
                                Saved ({{ProgressApplications.length}})
                            </template>
                            <SavedApplicationsDisplay v-if="ProgressApplications.length > 0"
                                :savedApplications="ProgressApplications"
                                :savedApplicationsType="InProgressApplicationType"
                                @GoToApp="GOTO_SAVEDAPP"
                                @DeActivateSavedApp="DeActivateSavedApp" 
                                @CopyApplication = "CopyApplication"
                                @displayAlertMsg = "DisplayAlertMsg"
                                @switchTab = "SwitchTab"
                                >
                            </SavedApplicationsDisplay>  
                        </b-tab>

                        <b-tab title-item-class="myTab mt-1">
                            <template #title>
                                Submitted ({{SubmittedApplications.length}})
                            </template>

                            <SavedApplicationsDisplay v-if="SubmittedApplications.length > 0"
                                :savedApplications="SubmittedApplications"
                                :savedApplicationsType="SubmittedApplicationType"
                                @GoToApp="GOTO_SAVEDAPP"
                                @DeActivateSavedApp="DEACTIVE_SAVEDFORMDATA"
                                @CopyApplication = "COPY_SAVEDAPP"
                                @displayAlertMsg = "DisplayAlertMsg"
                                @switchTab = "SwitchTab"
                                >
                            </SavedApplicationsDisplay>  
                            
                        </b-tab>
                    </b-tabs>
                <!--</b-card>-->
            <!--</div>-->
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters} from "vuex";  //, mapState, mapGetters
import SavedApplicationsDisplay from '@/components/SavedApplicationsDisplay.vue';
import AlertMessage from "@/components/PagesRelated/AlertMessage";
export default{
    name:'SavedApplications',
    components: { 
        SavedApplicationsDisplay,
        AlertMessage
        },
    props: {
        //TOTEST:
        savedApplications: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            displayAlert:false,
            alertMessage: '',
            alertType:'',
            tabIndex:0,
            //getSavedApplications: this.savedApplications,
            InProgressApplicationType: 'progress',
            SubmittedApplicationType: 'submitted',

            //TOTEST:
            //savedApplications:[]
        }
    },

    computed:{
        ProgressApplications()
        {
            //this.InProgressApplicationType= "progress";
            return this.savedApplications.filter(x => !x.IsSubmitted);   
        },
        SubmittedApplications()
        {
            //this.SubmittedApplicationType= "submitted";
            return this.savedApplications.filter(x => x.IsSubmitted);
        },

        //TOTEST:
        /*
        GetSavedApplications()
        {
            return this.$store.getters.formSaveDataList;
            //return this.$store.state.formSaveDataList;
            //return this.formSaveDataList;
        },
        
        //...mapState(['formSaveDataList'])
        */
    },
    methods:{
        DeActivateSavedApp(savedAppId)
        {
            this.DEACTIVE_SAVEDFORMDATA(savedAppId).then(resp => {
                if (resp=='error_deactivate_savedapplication')
                {
                    this.DisplayAlertMsg({displayStatus:true, msg:'There was an issue processing your request.  Please contact website admin.', alertType:'warning', timeOut: 5000});
                }
                else 
                {
                    this.DisplayAlertMsg({displayStatus:true, msg:'Your delete request is completed.', alertType:'info', timeOut: 5000});
                }
                    
            },err => {
                //this.DisplayAlertMsg({displayStatus:true, msg:'There was an issue processing your request.  Please contact website admin.', alertType:'warning', timeOut: 5000});
                this.DisplayAlertMsg({displayStatus:true, msg:err, alertType:'warning', timeOut: 5000});
            });
        },  
        CopyApplication(appIndex)
        {
            this.COPY_SAVEDAPP(appIndex).then(resp => {
                if (resp=='input error')
                {
                    this.DisplayAlertMsg({displayStatus:true, msg:'There was an issue processing your request.  Please contact website admin.', alertType:'warning', timeOut: 5000});
                }           
                else if(resp=='saving process error')
                {
                    this.DisplayAlertMsg({displayStatus:true, msg:'There was an issue processing your request.  Please contact website admin.', alertType:'warning', timeOut: 5000});
                }                 
                else if(resp=='success')
                {
                    this.DisplayAlertMsg({displayStatus:true, msg:'Your copy request is completed.', alertType:'info', timeOut: 5000});
                }                
            },err => {
                this.DisplayAlertMsg({displayStatus:true, msg: err, alertType:'warning', timeOut: 5000});
            });

        },
        DisplayAlertMsg(alertObj)
        {
            this.displayAlert = alertObj.displayStatus;
            this.alertMessage = alertObj.msg;
            this.alertType = alertObj.alertType;
            setTimeout(() => {this.displayAlert = false;}, alertObj.timeOut);      
        },
        SwitchTab(tabIndex)
        {
             this.tabIndex = tabIndex;
        },
        

        ...mapActions(["GOTO_SAVEDAPP","DEACTIVE_SAVEDFORMDATA","SAVE_FORMDATA","COPY_SAVEDAPP"]),
    },
    mounted(){
        //TOTEST:
        //this.$store.dispatch("RETRIEVE_SAVEDFORMDATA"); 
        //this.savedApplications = this.GetSavedApplications;


    },
};
</script>


